import { Button, Card, Input, Popconfirm, Select } from "antd";
import { Draggable } from "react-beautiful-dnd";
import Condition from "./Condition/Condition";
import Then from "./Then/Then";
import { DeleteFilled, PlusOutlined } from "@ant-design/icons";
import styles from "./ConditionBlock.module.css";
import { memo, useMemo } from "react";
import _ from "underscore";

const ConditionBlock = ({
  id,
  block,
  index,
  condition,
  then,
  type,
  title,
  onChange,
  setNewConditionId,
  newConditionId,
  setNewThenId,
  newThenId,
  removeBlock,
  questions,
  arrayOfConditions,
  conditionsClone,
}) => {
  const addCondition = () => {
    const newCondition = [
      ...condition,
      {
        id: newConditionId,
        if: { type: "is", value: null },
        main: { questionId: null },
      },
    ];
    setNewConditionId((value) => value + 1);
    onChange("condition", newCondition);
  };
  const removeCondition = (conditionId) => {
    const newCondition = [];
    condition.forEach((c) => {
      if (conditionId !== c.id) {
        newCondition.push(c);
      }
    });
    onChange("condition", newCondition);
  };
  const editCondition = (conditionId, field, value) => {
    const newCondition = [];
    condition.forEach((c) => {
      if (conditionId === c.id) {
        const newC = JSON.parse(JSON.stringify(c));
        newC[field] = value;
        newCondition.push(newC);
      } else {
        newCondition.push(c);
      }
    });
    onChange("condition", newCondition);
  };
  const addThen = () => {
    const newThen = [
      ...then,
      {
        id: newThenId,
        action: "show",
        target: { questionId: null, answerId: null },
      },
    ];
    setNewThenId((value) => value + 1);
    onChange("then", newThen);
  };
  const removeThen = (thenId) => {
    const newThen = [];
    then.forEach((t) => {
      if (thenId !== t.id) {
        newThen.push(t);
      }
    });
    onChange("then", newThen);
  };
  const editThen = (thenId, field, value) => {
    const newThen = [];
    then.forEach((t) => {
      if (thenId === t.id) {
        const newT = JSON.parse(JSON.stringify(t));
        newT[field] = value;
        newThen.push(newT);
      } else {
        newThen.push(t);
      }
    });
    onChange("then", newThen);
  };

  const isChanged = useMemo(() => {
    const cloneCond = conditionsClone?.find((e) => e.id === block.id);

    if (!cloneCond) return true;
    const { order: a, ...other } = cloneCond;
    const { order: o, ...original } = block;
    return !_.isEqual(other, original);
  }, [conditionsClone, condition]);

  return (
    <Draggable draggableId={`id_${id}`} index={index}>
      {(provided) => (
        <div
          id={"block_" + id}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
        >
          <div style={{ width: "100%" }}>
            <p style={{ textAlign: "center" }}>بلوک قانون شماره {index + 1}</p>
            <Card
              style={{
                backgroundColor: "rgba(9, 39, 100, 0.2)",
                border: isChanged ? `4px solid #EED12A` : `2px solid black`,
              }}
              title={
                <Input
                  defaultValue={title}
                  onBlur={(e) => {
                    onChange("title", e.target.value);
                  }}
                  style={{
                    width: "20rem",
                  }}
                  placeholder="عنوان بلوک"
                />
              }
              extra={
                <>
                  <Select
                    onChange={(value) => {
                      onChange("type", value);
                    }}
                    style={{
                      width: "10rem",
                      textAlign: "center",
                      marginLeft: "0.5rem",
                    }}
                    defaultValue={type}
                  >
                    <Select.Option value="AND">AND</Select.Option>
                    <Select.Option value="OR">OR</Select.Option>
                  </Select>
                  <Popconfirm
                    title="آیا از حذف بلوک شرط مطمئن هستید؟"
                    onConfirm={removeBlock}
                  >
                    <Button danger>حذف بلوک</Button>
                  </Popconfirm>
                </>
              }
            >
              <p>شرایط</p>
              <div className={styles.CondtionGuide}>
                <div className={styles.GuideCell}>سوال</div>
                <div className={styles.GuideCell}>وضعیت</div>
                <div className={styles.GuideCell}>پاسخ</div>
              </div>
              {condition.map((con) => {
                return (
                  <div key={con.id} className={styles.ConditionContainer}>
                    <Condition
                      {...con}
                      questions={questions}
                      onChange={(field, value) => {
                        editCondition(con.id, field, value);
                      }}
                    />
                    <div className={styles.ButtonContainer}>
                      <Popconfirm
                        title="از حذف شرط مطمئن هستید؟"
                        onConfirm={() => {
                          removeCondition(con.id);
                        }}
                      >
                        <Button danger type="text" icon={<DeleteFilled />} />
                      </Popconfirm>
                    </div>
                  </div>
                );
              })}
              <Button
                onClick={addCondition}
                icon={<PlusOutlined />}
                type="dashed"
                style={{ width: "100%" }}
              >
                اضافه کردن شرط
              </Button>
              <p>عملیات</p>
              <div className={styles.ThenGuide}>
                <div className={styles.GuideCell}>عملیات</div>
                <div className={styles.GuideCell}>سوال</div>
                <div className={styles.GuideCell}>گزینه</div>
              </div>
              {then.map((t) => {
                return (
                  <div key={t.id} className={styles.ThenContainer}>
                    <Then
                      thenId={t.id}
                      arrayOfConditions={arrayOfConditions}
                      questions={questions}
                      onChange={(field, value) => {
                        editThen(t.id, field, value);
                      }}
                      {...t}
                    />
                    <div className={styles.ButtonContainer}>
                      <Popconfirm
                        title="از حذف عملیات مطمئن هستید؟"
                        onConfirm={() => {
                          removeThen(t.id);
                        }}
                      >
                        <Button danger type="text" icon={<DeleteFilled />} />
                      </Popconfirm>
                    </div>
                  </div>
                );
              })}
              <Button
                icon={<PlusOutlined />}
                onClick={addThen}
                type="dashed"
                style={{ width: "100%" }}
              >
                اضافه کردن عملیات
              </Button>
            </Card>
          </div>
        </div>
      )}
    </Draggable>
  );
};
export default memo(ConditionBlock);
